import fetchWithBody from "./_internal/_fetchWithBody.js";

export default fetchWithBody("PUT");
